import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort, SortDirection } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { Pregnancy } from '../../../shared-modules/student-health-shared/student-health-shared.model';
import * as moment from 'moment';
import { StudentHealthSharedService } from '../../../shared-modules/student-health-shared/student-health-shared.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { Subscription } from 'rxjs';
import { YearService } from '../../../shared-components/year/year.service';

@Component({
  selector: 'app-pregnancy',
  templateUrl: './pregnancy.component.html',
  styleUrls: ['./pregnancy.component.css']
})
export class PregnancyComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedStudent;
  dataSource = new TylerMatTableDataSource();
  defaultSorDirection: SortDirection = 'asc';
  pregnancyData: Pregnancy[] = [];
  columnsToDisplay = ['DateOfTest', 'DateExpecting', 'HospitalName', 'DateHomeTeachingStart', 'DateHomeTeachingEnd'];
  student360YearSubscription: Subscription;

  @ViewChild(MatSort) set sort(val: MatSort) {
    if (this.dataSource) {
      this.dataSource.sort = val;
    }
  }
  constructor(
    private studentHealthSharedService: StudentHealthSharedService,
    private studentService: StudentService,
    private yearService: YearService
  ) {
    this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
      this.getPregnancy();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedStudent.previousValue != undefined) {
      if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
        this.getPregnancy();
      }
    }
  }

  ngOnInit() {
    this.getPregnancy();
  }

  getPregnancy() {
    this.pregnancyData = [];
    this.dataSource = new TylerMatTableDataSource(this.pregnancyData);
    this.studentHealthSharedService.getPregnancyReadByStudentId(this.studentService.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id).subscribe(prData => {
      if (prData) {
        this.pregnancyData = prData;
        this.pregnancyData.forEach(pr => {
          if (moment(pr.DateOfTest, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') == '01/01/01') {
            pr.DateOfTest = null;
          }
          if (moment(pr.DateExpecting, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') == '01/01/01') {
            pr.DateExpecting = null;
          }
          if (moment(pr.DateHomeTeachingEnd, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') == '01/01/01') {
            pr.DateHomeTeachingEnd = null;
          }
          if (moment(pr.DateHomeTeachingStart, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') == '01/01/01') {
            pr.DateHomeTeachingStart = null;
          }
          if (moment(pr.DateOfDeliveryOrTermination, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') == '01/01/01') {
            pr.DateOfDeliveryOrTermination = null;
          }
        });

        this.dataSource = new TylerMatTableDataSource(this.pregnancyData);
        this.dataSource.sort = this.sort;
      }
    });
  }

  ngOnDestroy() {
    this.student360YearSubscription.unsubscribe();
  }

}
